import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../../locales/messages";

interface Props {
  open: boolean;
  onClose: () => void;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
}

const Pane = ({
  title,
  value,
}: {
  title: string;
  value?: Record<string, unknown>;
}) => (
  <Box
    sx={{
      flex: 1,
      p: 1.5,
      background: "#fafafa",
      borderRadius: 1,
      minWidth: 0,
    }}
  >
    <Typography variant="caption" color="text.secondary">
      {title}
    </Typography>
    <Box
      component="pre"
      sx={{
        m: 0,
        mt: 0.5,
        fontSize: 12,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}
    >
      {value ? JSON.stringify(value, null, 2) : "—"}
    </Box>
  </Box>
);

export function AppliedRevisionPreview({ open, onClose, before, after }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="applied-revision-preview"
    >
      <DialogTitle>{t(messages.Applied_Revision())}</DialogTitle>
      <DialogContent dividers>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <Pane title={t(messages.Before())} value={before} />
          <Pane title={t(messages.After())} value={after} />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
